import { render, staticRenderFns } from "./CheckoutButton.vue?vue&type=template&id=4ad518fa"
import script from "./CheckoutButton.vue?vue&type=script&lang=js"
export * from "./CheckoutButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports